import { render, staticRenderFns } from "./CheckMTGBalanceToGL.vue?vue&type=template&id=451a72be&"
import script from "./CheckMTGBalanceToGL.vue?vue&type=script&lang=js&"
export * from "./CheckMTGBalanceToGL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports